import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-appmobilesidemenu',
  templateUrl: './appmobilesidemenu.component.html',
  styleUrls: ['./appmobilesidemenu.component.css']
})
export class AppmobilesidemenuComponent implements OnInit {
  divselect: any;
  brandgroup : any;
  petgroup: any;
  showLevel1 = null;
  showLevel2 = null;
  constructor() {
    this.divselect = 0;
   }

  ngOnInit() {
  }
  setDivSelect1(){
    this.divselect = 1;
    this.brandgroup = undefined;
    this.petgroup = undefined;
  }
  setDivSelect0(){
    this.divselect = 0;
  }
  setDivSelect2(bg){
    this.divselect = 2;
    this.brandgroup = bg;
  }
  setDivSelect3(bg){
    this.divselect = 3;
    this.petgroup = bg;
  }
  toggleLevel1(idx) {
    if (this.isLevel1Shown(idx)) {
      this.showLevel1 = null;
    } else {
      this.showLevel1 = idx;
    }
  };
  toggleLevel2(idx) {
    if (this.isLevel2Shown(idx)) {
      this.showLevel2 = null;
    } else {
      this.showLevel2 = idx;
    }
  };
  isLevel2Shown(idx) {
    return this.showLevel2 === idx;
  };
  isLevel1Shown(idx) {
    return this.showLevel1 === idx;
  };
}
